
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","viewBox":"0 0 22 20","fill":"#2F6BF0","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.875 16.5a2.063 2.063 0 100 4.125 2.063 2.063 0 000-4.125zm0 2.75a.687.687 0 110-1.374.687.687 0 010 1.374zM15.125 16.5a2.063 2.063 0 100 4.126 2.063 2.063 0 000-4.126zm0 2.75a.687.687 0 110-1.375.687.687 0 010 1.375zM4.661 4.125l-.295-1.19a2.062 2.062 0 00-2.001-1.56h-.99V2.75h.99a.687.687 0 01.688.522L5.5 13.227l.254 1.025a2.062 2.062 0 002.022 1.56h9.412v-1.374H7.775a.688.688 0 01-.688-.523l-.082-.344 10.181-2.4a2.063 2.063 0 001.534-1.505l1.375-5.541H4.66zm12.753 5.211a.688.688 0 01-.515.502l-10.21 2.4L5.005 5.5H18.37l-.956 3.836z"}})])
          )
        }
      }
    